import 'cube-ui/src/common/stylus/index.styl'
import {
  Checkbox,
  ActionSheet,
  Popup,
  Button
} from 'cube-ui'
import Vue from 'vue'

Vue.use(Checkbox)
Vue.use(ActionSheet)
Vue.use(Popup)
Vue.use(Button)
